import componentShell from "./shell"
import AddExampleToCart from "@/common/components/add_example_to_cart"

export default componentShell(AddExampleToCart)
